import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import DistributorStep from "@funded-here-interface/common/src/Layouts/DistributorSteps/DistributorStep";
import { FC, ReactNode, Suspense } from "react";

import NavBar from "../../components/NavBar/NavBar";
import { useStyles } from "./Distributorlayout.styles";

interface IProps {
  content: ReactNode;
  showSteps?: boolean;
  step: number;
}

const DistributorLayout: FC<IProps> = ({ content, showSteps, step }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <NavBar />
      {showSteps && <DistributorStep currentStep={step} />}
      <div className={classes.stepContainer}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default DistributorLayout;
